(ns hai.ui.components.collection.search
  "Events and components for collection components, such as tables or comboboxes, that support
  search"
  (:require
   [hai.ui.components.collection.table :as-alias table]
   [hai.ui.components.form.input :as input]
   [hai.ui.rf-sugar :refer [<s >e defeffect defevent-fx]]
   [humbleai.belt.malli.transform.translate-keys :as translate-keys]
   [lambdaisland.ornament :as o]))

(defeffect ::on-search
  [[on-search search-string]]
  (when on-search
    (on-search search-string)))

(defevent-fx :table/on-search
  [{:keys [db]} {:table/keys [id on-search]}]
  (let [search-string (get-in db [:collections id :table/search-string])]
    {::on-search [on-search search-string]}))

(def SearchConfig
  "Collection-level config for the search bar, declared here and merged into the
  table schema (`table/StaticTable` + `table/EditableTable`) so `strip-extra-keys`
  keeps it through `decode-table-props` - otherwise the key would be stripped
  before `process-schema` ever saw it. Consumers pass short keys
  (`:search {:placeholder \"Search tasks…\"}`); these translate to the
  `:form.field/*` props `process-schema` merges onto the search field. Only a
  placeholder override for now - `:table/*` naming because collections grew out
  of the table."
  [:map
   [:table/search
    {:optional true
     ::translate-keys/from :search}
    [:map
     [:form.field/placeholder
      {:optional true
       ::translate-keys/from :placeholder}
      :string]]]])

(defn process-schema
  ([schema {:collection/keys [type] :as collection} props]
   (let [props (into {} (remove (comp nil? second) props))]
     (cond-> schema
       (= :query type)
       (conj [:table/search
              (merge
               {:optional true
                :form.field/placeholder "Search..."
                :form.field/on-change (fn [_]
                                        ;; TODO pagination concern
                                        (>e [:table/reset-cursors collection])
                                        (>e [:table/debounce-resolve collection]))}
               props)
              [:or :nil :string]]))))
  ([schema collection]
   ;; Feed the collection's declared `:table/search` config (a map of
   ;; `:form.field/*` props, currently just a placeholder) through as props so a
   ;; consumer can override the default "Search..." placeholder - the same props
   ;; path `searchable-multi-select` already uses.
   (process-schema schema collection (:table/search collection))))

(o/defstyled component :div
  :flex :flex-row
  :items-center
  :gap-3
  :w-100%
  [:> [:div :w-33%]]
  ([{:as table
     :collection/keys [type]
     {{:table/keys [search]} :form/fields} :table/form}]
   (when (= :query (:collection/type table))
     [input/field
      (assoc search
             :form.field/loading? @(<s [:table/resolving? table])
             :input/render input/radix)])))
